export class NavigationNumber {
    number : String ;
    q : {};
    sq : any[] ;
    isOpen : boolean ;

    constructor(obj , Q) {
        this.number = obj.q.label;
        this.q = obj.q;
        this.sq = obj.sq;
        this.isOpen = (Q && obj.q.label == Q.qNo)? Q.isOpen: false;
    }

    static fromJSONArray(array: Array<NavigationNumber>, Q : any = false): NavigationNumber[] {
        return array.map(obj => new NavigationNumber(obj , Q));
    }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/navigationNumber.ts